import { useState, useEffect } from 'react';

function useElementProperties(elementID) {
  var _useState = useState(undefined),
      elementProperties = _useState[0],
      setElementProperties = _useState[1];

  useEffect(function () {
    function handleResize() {
      setElementProperties(document.getElementById(elementID) ? document.getElementById(elementID).getBoundingClientRect() : null);
    }

    window.addEventListener('scroll', handleResize);
    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return (
        window.removeEventListener('resize', handleResize)
      )
    };
  }, []);
  return elementProperties;
}

export { useElementProperties };
//# sourceMappingURL=index.modern.js.map
